"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-fragments */
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const const_1 = require("@app/const");
const globals_1 = require("@app/const/globals");
require("../common/calendar-common.scss");
const capacities_1 = __importDefault(require("../common/capacities"));
const header_1 = __importDefault(require("../common/header"));
const section_1 = __importDefault(require("../common/section"));
const shift_templates_1 = __importDefault(require("../common/shift-templates"));
const statistics_1 = require("../common/statistics");
const connect_1 = __importDefault(require("./connect"));
const top_bar_1 = require("@app/component/pages/schedule/top-bar");
const use_compute_warnings_1 = require("@app/component/pages/schedule/util/use-compute-warnings");
const format_hours_1 = require("@app/util/format-hours");
const use_calendar_settings_1 = require("@app/util/use-calendar-settings");
const sort_by_1 = require("../common/sort-by");
/*
SUPPORTED PROPS
  view: if not passed, default to store.dalendar.view or to 'month'
  date: if not passed, default to store.dalendar.date or to current day moment()
*/
class CalendarManager extends react_1.default.Component {
    labelWidthRem;
    _isMounted;
    _alreadyProcessedOfferOpening;
    getCols;
    _cachedCols;
    _cachedColsKey;
    _shiftWarningCount;
    _timeOffWarningCount;
    getSortedRows;
    getFilteredRows;
    getSectionRows;
    reloadWorkspaceEvents;
    cleanUpCalendarFilters;
    constructor(props) {
        super(props);
        this.state = {
            sortedBy: window.localStorage.getItem('ds-calendar-sort') || 'SORT_BY_NAME',
            countWarnings: 0,
            countWarningsByType: { all: 0 },
            countWarningsByDate: {},
        };
        this.labelWidthRem = 9.5;
        this._isMounted = false;
        this._alreadyProcessedOfferOpening = false;
        this._cachedCols = null;
        this._cachedColsKey = null;
        this._shiftWarningCount = 0;
        this._timeOffWarningCount = 0;
        this.getCols = this._getCols.bind(this);
        this.getSortedRows = this._getSortedRows.bind(this);
        this.getFilteredRows = this._getFilteredRows.bind(this);
        this.getSectionRows = this._getSectionRows.bind(this);
        this.reloadWorkspaceEvents = this._reloadWorkspaceEvents.bind(this);
        this.cleanUpCalendarFilters = this._cleanUpCalendarFilters.bind(this);
    }
    // deletes those calendar filters that are no longer valid. specifically:
    //   - user filters for users who have been deleted
    //   - locality filters for localities that no longer exists
    //   - position filters for positions that no longer exists
    //   - type='unavailability' or type='shift' filters, since they are deprecated
    _cleanUpCalendarFilters() {
        const { calendarFilters, setCalendarFilters, employees, positions, workspace } = this.props;
        const updatedCalendarFilters = [];
        const needsToBeRemoved = (cf) => {
            // is user still on WS?
            if (cf.userId && Object.keys(employees).length) {
                if (!Object.keys(employees).includes(cf.userId))
                    return true;
            }
            // is locality still on WS?
            if (cf.localityId && workspace && workspace.localities) {
                if (!workspace.localities.find((l) => l?.id === cf.localityId))
                    return true;
            }
            // is position still on WS?
            if ((cf.peopleWithPositionId || cf.data?.positionId) && positions) {
                if (cf.peopleWithPositionId) {
                    if (!positions.find((p) => !p.archived && p.id === cf.peopleWithPositionId))
                        return true;
                }
                if (cf.data?.positionId) {
                    if (!positions.find((p) => !p.archived && p.id === cf.data.positionId))
                        return true;
                }
            }
            // deprecated 'type' filters
            if (cf.type && ['shift', 'unavailability'].includes(cf.type)) {
                return true;
            }
            // old implementation of timeOffs (hard unavs) filter with data.type: HARD
            if (cf?.data?.type === 'HARD') {
                return true;
            }
            // old implementation of the 'rowsWithoutEventsHidden' filter
            if (cf.events?.length &&
                !cf.events.some((ev) => util_1.miscUtil.safeStringify(ev !== util_1.miscUtil.safeStringify([])))) {
                return true;
            }
            return false;
        };
        calendarFilters.forEach((cf) => {
            if (!needsToBeRemoved(cf))
                updatedCalendarFilters.push(cf);
        });
        if (util_1.miscUtil.safeStringify(updatedCalendarFilters) !==
            util_1.miscUtil.safeStringify(calendarFilters))
            setCalendarFilters(updatedCalendarFilters);
    }
    componentDidUpdate(prevProps) {
        const { setModal, modal, offers } = this.props;
        // re-compute warning numbers if calendar's date or view or no. of warnings changed
        const prevShiftWarningCount = this._shiftWarningCount;
        if (prevProps.shifts !== this.props.shifts) {
            this._shiftWarningCount = this.props.shifts.reduce((a, s) => a + (s.warnings?.length ?? 0), 0);
        }
        const prevTimeOffWarningCount = this._timeOffWarningCount;
        if (prevProps.timeOffs !== this.props.timeOffs) {
            this._timeOffWarningCount = this.props.timeOffs.reduce((a, s) => a + (s.warnings?.length ?? 0), 0);
        }
        if (prevProps.calendar?.date !== this.props.calendar?.date ||
            prevProps.calendar?.view !== this.props.calendar?.view ||
            prevShiftWarningCount !== this._shiftWarningCount ||
            prevTimeOffWarningCount !== this._timeOffWarningCount ||
            util_1.miscUtil.safeStringify(prevProps.calendarFilters) !==
                util_1.miscUtil.safeStringify(this.props.calendarFilters)) {
            setTimeout(() => {
                this.setState((s) => Object.assign({}, s, (0, use_compute_warnings_1.computeWarningNumbers)(this.props.shifts, this.props.timeOffs, this.props.calendarFilters, this.props.calendar)));
            }, 500);
        }
        // display the auto-planner panel in the assistant column when there is a plan
        if (['prepare', 'process'].includes(this.props?.workspace?.currentPlan?.status ?? '') &&
            !this.props.isPlanningPanelOpen) {
            this.props.openPlanning();
        }
        const searchParams = new URLSearchParams(window.location.search);
        const isTryingToOpenOffer = searchParams.has('offer');
        const offId = searchParams.get('offer');
        if (isTryingToOpenOffer) {
            if ((0, util_1.isNotNull)(modal))
                return;
            if (this._alreadyProcessedOfferOpening === offId)
                return;
            const off = offers?.find((o) => o.id === offId);
            if (off) {
                setModal('offers', {
                    selectedShiftIds: [off.shiftId],
                    action: off.status === 'managerRequestApproval'
                        ? 'approve'
                        : off.status === 'managerResultApproval'
                            ? 'resolve'
                            : off.status === 'employeeReplies'
                                ? 'show'
                                : 'create',
                    afterClose: () => {
                        util_1.routeUtil.navigate(window.location.pathname);
                    },
                });
                this._alreadyProcessedOfferOpening = false;
            }
            else {
                util_1.notification.warn({ code: 'offerNoLongerExists' });
                this._alreadyProcessedOfferOpening = offId;
            }
        }
    }
    componentDidMount() {
        this._isMounted = true;
        const { calendar, setCalendar } = this.props;
        // set or update the store.calendar.[view/date] - these are used for rendering
        let { date, view } = this.props;
        if (!date) {
            date = (0, moment_1.default)().startOf('day');
        }
        else {
            date = (0, moment_1.default)(date).startOf('day');
        }
        if (!view) {
            if (calendar?.view) {
                view = calendar.view;
            }
            else {
                view = 'month';
            }
        }
        const viewFromLocalStorage = localStorage.getItem('ds-calendar-view');
        const dateFromLocalStorage = localStorage.getItem('ds-calendar-date');
        if ((0, util_1.isValue)(viewFromLocalStorage) &&
            ['day', 'week', 'month'].includes(viewFromLocalStorage))
            view = viewFromLocalStorage;
        if ((0, util_1.isValue)(dateFromLocalStorage) &&
            dateFromLocalStorage.length > 0 &&
            (0, moment_1.default)(dateFromLocalStorage).isValid())
            date = (0, moment_1.default)(dateFromLocalStorage);
        // force 'day' view on mobile devices
        // if (window.matchMedia('only screen and (max-device-width: 768px)').matches) {
        //  console.log('Mobile device - setting calendar to day view.')
        //  view = 'day'
        // }
        // execute the store.calendar update
        if (!calendar ||
            !(0, moment_1.default)(calendar.date).isSame(date, 'day') ||
            calendar.view !== view ||
            typeof calendar.roleStats === 'undefined' ||
            typeof calendar.changedShiftsCount === 'undefined') {
            setCalendar({
                date,
                view,
            });
        }
        // set up the drag&drop handler 'document.ondragover'
        document.ondragover = (e) => {
            // @ts-expect-error
            window.dragPageX = e.pageX;
            // @ts-expect-error
            window.dragPageY = e.pageY;
        };
        this.reloadWorkspaceEvents();
        this.setState((s) => Object.assign({}, s, (0, use_compute_warnings_1.computeWarningNumbers)(this.props.shifts, this.props.timeOffs, this.props.calendarFilters, this.props.calendar)));
        this._shiftWarningCount =
            this.props.shifts?.reduce((a, s) => a + (s.warnings?.length ?? 0), 0) ?? 0;
        this._timeOffWarningCount =
            this.props.timeOffs?.reduce((a, s) => a + (s.warnings?.length ?? 0), 0) ?? 0;
        setTimeout(() => {
            // call the calendar filter cleanup after some time, once the employees, positions, etc. had enough time to
            // be loaded, because the cleanup function needs all that data to fully function
            this.cleanUpCalendarFilters();
        }, 5000);
    }
    componentWillUnmount() {
        this._isMounted = false;
        // clear the drag&drop handler 'document.ondragover'
        document.ondragover = () => { };
    }
    // load the WS events (closed days and day notes)
    // and add 'is-closed' CSS class to relevant columns
    _reloadWorkspaceEvents() {
        const { loadWorkspaceEvents, calendar } = this.props;
        const per = util_1.calendarUtil.getReloadPeriod(calendar);
        if (per) {
            loadWorkspaceEvents({
                type: null,
                period: per,
            });
        }
    }
    // returns a list of calendar columns corresponding to days or hours (depending on the view)
    _getCols() {
        const view = this.props.calendar.view;
        const date = (0, moment_1.default)(this.props.calendar.date);
        if (!view || !date)
            return [];
        const key = `${view}__${date.valueOf()}`;
        if (this._cachedColsKey === key && this._cachedCols)
            return this._cachedCols;
        const ret = [];
        if (view === 'day') {
            for (let h = 0; h <= 23; h++) {
                ret.push({
                    date,
                    hour: h,
                });
            }
        }
        if (view === 'week') {
            const weekStart = date.startOf('week');
            for (let d = 0; d <= 6; d++) {
                ret.push({
                    date: weekStart.clone().add(d, 'days'),
                });
            }
        }
        if (view === 'month') {
            const monthStart = date.startOf('month');
            for (let dm = 0; dm < date.daysInMonth(); dm++) {
                ret.push({
                    date: monthStart.clone().add(dm, 'days'),
                });
            }
        }
        this._cachedCols = ret;
        this._cachedColsKey = key;
        return ret;
    }
    _getEmployeeIcon(ee) {
        if (ee.employeeWarnings?.length) {
            if (ee.employeeWarnings.length === 1 &&
                ee.employeeWarnings[0].type === 'dummy')
                return null;
            const redWarningTypes = [
                'workTimeAvg',
                'workSaldo',
                'outOfContract',
                'overtimeReached',
                'underUtilized',
                'underUtilizedShifts',
            ];
            let extraClass = 'is-minor-warning';
            ee.employeeWarnings.forEach((w) => {
                if (redWarningTypes.includes(w.type))
                    extraClass = 'is-major-warning';
            });
            return { ico: 'exclamation', extraClass };
        }
        return null;
    }
    // returns a list of rows with all the content for one of the sections
    _getSectionRows(whichSection, cols, dateStringsInPeriod, shiftsInPeriod, availsInPeriod, timeOffsInPeriod) {
        const { employees, calendarFilters, isPluginEnabled } = this.props;
        const { view, date } = this.props.calendar;
        let ret = [];
        // top sections
        if (['unassigned', 'offers'].includes(whichSection)) {
            // row with unassigned shifts
            if (whichSection === 'unassigned') {
                const unassignedShifts = shiftsInPeriod.filter((ev) => !ev.userId && !ev.hasOffer);
                const newRowUnass = {
                    labelData: {
                        icon: 'clipboard',
                        title: (0, util_1.t)('OPEN_SHIFTS'),
                        text: undefined,
                    },
                    events: cols.map(() => []),
                    employee: 'unassigned',
                };
                let unassignedMins = 0;
                unassignedShifts.forEach((ev) => {
                    if (!ev?.period?.start || !ev.period.end)
                        return;
                    let colNum = null;
                    if (view === 'day') {
                        colNum = (0, moment_1.default)(ev.period.start).hour();
                    }
                    else {
                        colNum = dateStringsInPeriod.indexOf((0, moment_1.default)(ev.period.start).format('YYYY-MM-DD'));
                    }
                    unassignedMins += (0, moment_1.default)(ev.period.end).diff(ev.period.start) / 60000;
                    const evts = newRowUnass.events[colNum];
                    if (evts) {
                        newRowUnass.events[colNum].push({
                            type: 'shift',
                            data: ev,
                        });
                    }
                });
                newRowUnass.labelData.text =
                    (0, format_hours_1.formatHours)(unassignedMins / 60) +
                        ' / ' +
                        ((0, util_1.t)('X_SHIFTS', { x: unassignedShifts?.length?.toString() ?? 0 }) ?? '');
                ret.push(newRowUnass);
            }
            // row with offers
            if (whichSection === 'offers' && isPluginEnabled('offers')) {
                const offeredShifts = shiftsInPeriod.filter((ev) => ev.hasOffer && ev.hasOffer.status !== 'resolved');
                const newRowOff = {
                    labelData: {
                        icon: 'clipboard',
                        title: (0, util_1.t)('CONTESTS'),
                        text: undefined,
                    },
                    events: cols.map(() => []),
                    employee: 'offers',
                };
                let offerMins = 0;
                offeredShifts.forEach((ev) => {
                    if (!ev?.period?.start || !ev.period.end)
                        return;
                    let colNum = null;
                    if (view === 'day') {
                        colNum = (0, moment_1.default)(ev.period.start).hour();
                    }
                    else {
                        colNum = dateStringsInPeriod.indexOf((0, moment_1.default)(ev.period.start).format('YYYY-MM-DD'));
                    }
                    offerMins += (0, moment_1.default)(ev.period.end).diff(ev.period.start) / 60000;
                    const evts = newRowOff.events[colNum];
                    if (evts) {
                        newRowOff.events[colNum].push({
                            type: 'shift',
                            data: ev,
                        });
                    }
                });
                newRowOff.labelData.text =
                    (0, format_hours_1.formatHours)(offerMins / 60) +
                        ' / ' +
                        ((0, util_1.t)('X_SHIFTS', { x: offeredShifts?.length?.toString() ?? 0 }) ?? '');
                ret.push(newRowOff);
            }
        }
        // bottom section
        if (whichSection === 'bottom') {
            // one row per employee
            util_1.sortUtil.sortEmployees(employees).forEach((ee) => {
                const empIco = this._getEmployeeIcon(ee);
                const filteredShiftsInPeriod = util_1.calendarUtil.getFilteredEvents(shiftsInPeriod.filter((ev) => ev.userId === ee.id), calendarFilters);
                const filteredAvailsInPeriod = util_1.calendarUtil.getFilteredEvents(availsInPeriod.filter((ev) => ev.userId === ee.id), calendarFilters);
                const filteredTimeOffsInPeriod = calendarFilters.some((f) => f.type === 'timeOff')
                    ? []
                    : util_1.calendarUtil.getFilteredEvents(timeOffsInPeriod.filter((ev) => ev.userId === ee.id), calendarFilters);
                // this is used for 2 things:
                //   - one of the calendar filters and
                //   - skipping external emps without shifts
                const userShiftsCount = filteredShiftsInPeriod.length;
                // this is used for calendar filters
                const userEventsCount = userShiftsCount +
                    filteredAvailsInPeriod.length +
                    filteredTimeOffsInPeriod.length;
                // this is used for 2 things:
                //   - by one of the calendar filters to hide the users that have no active contracts in displayed calendar period
                //   - by Row when displaying the ends and starts of user's contracts
                const userHasContractsInCalendarPeriod = Boolean(ee.contracts?.some((con) => con.period &&
                    (!con.period.start ||
                        (0, moment_1.default)(con.period.start).isSameOrBefore((0, moment_1.default)(date).endOf(view))) &&
                    (!con.period.end ||
                        (0, moment_1.default)(con.period.end).isSameOrAfter((0, moment_1.default)(date).startOf(view)))));
                // skip external employees with no events
                if (ee.external && userEventsCount === 0)
                    return;
                // initialize row contents and set the data for label
                const newRow = {
                    labelData: {
                        icon: empIco ? empIco.ico : null,
                        iconExtraClass: empIco ? empIco.extraClass : null,
                        user: ee,
                        userShiftsCount,
                        userEventsCount,
                        userHasContractsInCalendarPeriod,
                        title: `${ee.lastName} ${ee.firstName}`,
                        positions: ee.positions,
                    },
                    events: cols.map(() => []),
                    employee: ee.id,
                };
                ret.push(newRow);
            });
        }
        // filtering the rows
        ret = this.getFilteredRows(ret);
        // sorting rows in bottom section
        if (whichSection === 'bottom') {
            ret = this.getSortedRows(ret, cols, shiftsInPeriod);
        }
        return ret;
    }
    _getFilteredRows(rows) {
        const { calendarFilters } = this.props;
        if (!calendarFilters?.length)
            return rows;
        const filteredLocalities = calendarFilters
            .filter((fil) => fil.localityId && fil.localityId !== 'noLocality')
            .map((fil) => fil.localityId);
        const filteredPositions = calendarFilters
            .filter((fil) => fil.peopleWithPositionId && fil.peopleWithPositionId !== globals_1.NO_POSITION)
            .map((fil) => fil.peopleWithPositionId);
        return rows
            .map((row) => {
            // first, deal with special 'userId' filters: skip the whole rows if row.employee matches
            if (calendarFilters.find((fil) => fil.userId &&
                !['offers', 'unassigned'].includes(fil.userId) &&
                fil.userId === row.employee))
                return null;
            // also, deal with special 'labelData' filters similarly: skip the whole rows
            const labelDataFilters = calendarFilters.filter((fil) => fil.labelData);
            if (labelDataFilters.find((fil) => {
                const rowWithFilterApplied = util_1.miscUtil.mergeDeep(row, fil);
                return (util_1.miscUtil.safeStringify(row) ===
                    util_1.miscUtil.safeStringify(rowWithFilterApplied));
            }))
                return null;
            // also, deal with the special 'peopleWithPositionId' filters: skip the whole rows if
            // there are some position filters active and the corresponding user doesn't
            // have position that's not filtered out
            if (!['unassigned', 'offers'].includes(row.employee) &&
                calendarFilters.find((fil) => fil.peopleWithPositionId)) {
                // skip users without position if NO_POSITION filter is set
                if (calendarFilters.find((fil) => fil.peopleWithPositionId === globals_1.NO_POSITION)) {
                    if (!row.labelData.user?.positions?.length) {
                        return null;
                    }
                }
                // skip users with some positions, but no remaining position after applying positionId filters
                if (row.labelData.user?.positions?.length) {
                    const remainingUsersPositions = row.labelData.user.positions.filter((pos) => !filteredPositions.includes(pos.id));
                    if (remainingUsersPositions.length === 0)
                        return null;
                }
            }
            // also, deal with the special 'localityId' filters: skip the whole rows if
            // there are some locality filters active and the corresponding user doesn't
            // have locality that's not filtered out
            if (!['unassigned', 'offers'].includes(row.employee) &&
                calendarFilters.find((fil) => fil.localityId)) {
                // skip users without locality if NO_LOCALITY filter is set
                if (calendarFilters.find((loc) => loc.localityId === globals_1.NO_LOCALITY)) {
                    if (!row.labelData.user?.localities?.length) {
                        return null;
                    }
                }
                // skip users with some localities, but no remaining locality after applying localityId filters
                if (row.labelData.user?.localities?.length) {
                    const remainingUsersLocalities = row.labelData.user.localities.filter((locId) => !filteredLocalities.includes(locId));
                    if (remainingUsersLocalities.length === 0)
                        return null;
                }
            }
            return row;
        })
            .filter((row) => !!row);
    }
    _getSortedRows(rows, cols, shiftsInPeriod) {
        const { positions, workspace, calendarFilters, calendar } = this.props;
        let ret = rows;
        // by name
        if (this.state.sortedBy === sort_by_1.SORT_BY.NAME) {
            // nothing to do here - the 'ret' is already sorted by name
        }
        // by start of 1st shift
        if (this.state.sortedBy === sort_by_1.SORT_BY.SHIFT_START) {
            const empsFirstShiftTime = {};
            shiftsInPeriod.forEach((s) => {
                if (!s.userId)
                    return;
                if (!empsFirstShiftTime[s.userId]) {
                    empsFirstShiftTime[s.userId] = s.period.start;
                }
                else {
                    if ((0, moment_1.default)(empsFirstShiftTime[s.userId]).isAfter(s.period.start))
                        empsFirstShiftTime[s.userId] = s.period.start;
                }
            });
            ret = ret.sort((a, b) => {
                if (!empsFirstShiftTime[a.employee] && empsFirstShiftTime[b.employee])
                    return 1;
                if (empsFirstShiftTime[a.employee] && !empsFirstShiftTime[b.employee])
                    return -1;
                return (0, moment_1.default)(empsFirstShiftTime[a.employee]).isAfter(empsFirstShiftTime[b.employee])
                    ? 1
                    : -1;
            });
        }
        // by position
        if (this.state.sortedBy === sort_by_1.SORT_BY.POSITION) {
            let newRet = [];
            positions
                .filter((p) => !p.archived)
                .sort((a, b) => {
                return (a.name ?? 0) > (b.name ?? 0) ? 1 : -1;
            })
                .forEach((pos) => {
                if (calendarFilters.find((fil) => fil.peopleWithPositionId === pos.id))
                    return;
                // get rows for this section and add sort-related data to them (they're then
                // used to make events irrelevant for this section transparent)
                const matchingRows = ret
                    .filter((r) => r.labelData.user.positions?.find((p) => p.id === pos.id))
                    .map((row) => {
                    return Object.assign({}, row, {
                        sortData: { sortedBy: 'SORT_BY_POSITION', id: pos.id },
                    });
                });
                // add position name section separator
                newRet.push({
                    divider: true,
                    dividerContent: react_1.default.createElement(_ui_1.Position, { pos: pos }),
                    events: cols.map(() => []),
                });
                newRet = newRet.concat(matchingRows);
            });
            // section for emps with no position
            if (!calendarFilters.find((fil) => fil.peopleWithPositionId === globals_1.NO_POSITION)) {
                newRet.push({
                    divider: true,
                    dividerContent: (0, util_1.t)('SORT_BY_POSITION_NO_POS'),
                    events: cols.map(() => []),
                });
                newRet = newRet.concat(ret.filter((r) => !r.labelData.user.positions || r.labelData.user.positions.length === 0));
            }
            ret = newRet;
        }
        // by locality
        if (this.state.sortedBy === sort_by_1.SORT_BY.LOCALITY) {
            let newRet = [];
            if (workspace?.localities) {
                workspace.localities.map((ct) => {
                    if (calendarFilters.find((fil) => fil.localityId === ct?.id))
                        return null;
                    // get rows for this section and add sort-related data to them (they're then
                    // used to make events irrelevant for this section transparent)
                    const matchingRows = ret
                        .filter((r) => r.labelData.user.localities?.includes(ct?.id))
                        .map((row) => {
                        return Object.assign({}, row, {
                            sortData: { sortedBy: 'SORT_BY_LOCALITY', id: ct?.id },
                        });
                    });
                    // add locality name section separator
                    if (matchingRows.length) {
                        newRet.push({
                            divider: true,
                            dividerContent: (react_1.default.createElement("div", { className: 'ds-locality-divider' },
                                react_1.default.createElement(_ui_1.Icon, { ico: 'location' }),
                                '(' + (ct?.shortName ?? '??') + ') ' + (ct?.name ?? '??'))),
                            events: cols.map(() => []),
                        });
                    }
                    newRet = newRet.concat(matchingRows);
                    return null;
                });
            }
            // section for emps with no locality
            if (!calendarFilters.find((fil) => fil.localityId === globals_1.NO_LOCALITY)) {
                newRet.push({
                    divider: true,
                    dividerContent: (react_1.default.createElement("div", { className: 'ds-locality-divider' },
                        react_1.default.createElement(_ui_1.Icon, { ico: 'location' }),
                        (0, util_1.t)('SORT_BY_LOCALITY_NO_LOC'))),
                    events: cols.map(() => []),
                });
                newRet = newRet.concat(ret.filter((r) => !r.labelData.user.localities ||
                    r.labelData.user.localities.length === 0));
            }
            ret = newRet;
        }
        // by contract type
        if (this.state.sortedBy === sort_by_1.SORT_BY.CONTRACT) {
            let newRet = [];
            const calendatDisplayedPeriodStart = (0, moment_1.default)(calendar?.date).startOf(calendar?.view);
            const calendatDisplayedPeriodEnd = (0, moment_1.default)(calendar?.date).endOf(calendar?.view);
            const containsExternalEmployees = this.props.shifts.some((shift) => shift.contractType === 'external');
            if (workspace?.contractTypes) {
                ;
                [
                    ...(workspace.contractTypes ?? []),
                    containsExternalEmployees
                        ? {
                            id: 'external',
                            name: (0, util_1.t)('ORG_SP_SETTINGS_MODULES_EXTERNAL'),
                            rules: {
                                vacationFund: true,
                                fixedWorkHours: false,
                            },
                        }
                        : undefined,
                ]
                    .filter(util_1.isValue)
                    .forEach((ct) => {
                    const matchingRows = ret
                        .filter((r) => {
                        const activeContracts = (r.labelData?.user?.contracts || []).filter((c) => !c.archived &&
                            !((c.period?.start &&
                                (0, moment_1.default)(c.period.start).isAfter(calendatDisplayedPeriodEnd)) ||
                                (c.period?.end &&
                                    (0, moment_1.default)(c.period.end).isBefore(calendatDisplayedPeriodStart))));
                        return activeContracts.some((c) => c.type === ct.id);
                    })
                        .map((row) => {
                        return Object.assign({}, row, {
                            sortData: { sortedBy: 'SORT_BY_CONTRACT', id: ct.id },
                        });
                    });
                    // add contract name separator
                    if (ct.id !== 'default' || matchingRows.length) {
                        newRet.push({
                            divider: true,
                            dividerContent: (react_1.default.createElement("div", { className: 'ds-contract-divider' },
                                react_1.default.createElement("div", null, (0, util_1.isValue)(ct.name) ? (0, util_1.t)(ct.name) : null))),
                            events: cols.map(() => []),
                        });
                    }
                    newRet = newRet.concat(matchingRows);
                });
            }
            // section for emps with no active contract
            // const noContrUsrs = ret.filter((r) => !r.labelData.user.contractId)
            const noContrUsrs = ret.filter((r) => {
                const activeContracts = (r.labelData?.user?.contracts || []).filter((c) => !c.archived &&
                    !((c.period?.start &&
                        (0, moment_1.default)(c.period.start).isAfter(calendatDisplayedPeriodEnd)) ||
                        (c.period?.end &&
                            (0, moment_1.default)(c.period.end).isBefore(calendatDisplayedPeriodStart))));
                return activeContracts.length === 0;
            });
            if (noContrUsrs.length) {
                newRet.push({
                    divider: true,
                    dividerContent: (react_1.default.createElement("div", { className: 'ds-locality-divider' }, (0, util_1.t)('SORT_BY_CONTRACT_NO_CON'))),
                    events: cols.map(() => []),
                });
                newRet = newRet.concat(noContrUsrs);
            }
            ret = newRet;
        }
        // by day part
        if (this.state.sortedBy === sort_by_1.SORT_BY.DAY_PART) {
            const empsInDayParts = {};
            const dayParts = util_1.timeUtil.getDayParts();
            dayParts.forEach((dp) => {
                empsInDayParts[dp.name] = [];
            });
            shiftsInPeriod.forEach((ev) => {
                if (!ev.userId)
                    return;
                const middleHour = util_1.timeUtil.getMiddleHour(ev.period.start, ev.period.end);
                dayParts.forEach((dp) => {
                    const dpStart = util_1.timeUtil.timeToDecimal(dp.start);
                    const dpEnd = util_1.timeUtil.timeToDecimal(dp.end);
                    let timeCond = false;
                    if (dp.conditionOperator === 'AND') {
                        timeCond = middleHour >= dpStart && middleHour < dpEnd;
                    }
                    else if (dp.conditionOperator === 'OR') {
                        timeCond = middleHour >= dpStart || middleHour < dpEnd;
                    }
                    if (timeCond && !empsInDayParts[dp.name].includes(ev.userId)) {
                        empsInDayParts[dp.name].push(ev.userId);
                    }
                });
            });
            let newRet = [];
            dayParts.forEach((dp) => {
                // add day part name separator
                newRet.push({
                    divider: true,
                    dividerContent: (react_1.default.createElement("div", { className: 'ds-part-of-day-divider' },
                        react_1.default.createElement(_ui_1.Icon, { ico: dp.ico }),
                        react_1.default.createElement("div", null, (0, util_1.t)(dp.name)))),
                    events: cols.map(() => []),
                    // @ts-expect-error not typed
                    dayPart: this.state.sortedBy === sort_by_1.SORT_BY.DAY_PART ? dp.name : undefined,
                });
                newRet = newRet.concat(ret
                    .filter((r) => empsInDayParts[dp.name].includes(r.employee))
                    .map((row) => ({
                    ...row,
                    sortData: { sortedBy: 'SORT_BY_DAY_PART', id: dp.name },
                })));
            });
            newRet.push({
                divider: true,
                dividerContent: (react_1.default.createElement("div", { className: 'ds-part-of-day-divider' },
                    react_1.default.createElement(_ui_1.Icon, { ico: _ui_1.Icon.ICONS.close1 }),
                    react_1.default.createElement("div", null, (0, util_1.t)('SORT_BY_DAY_PART_NO_SHIFTS')))),
                events: cols.map(() => []),
            });
            newRet = newRet.concat(ret.filter((r) => {
                let ok = true;
                dayParts.forEach((dp) => {
                    if (empsInDayParts[dp.name].includes(r.employee)) {
                        ok = false;
                    }
                });
                return ok;
            }));
            ret = newRet;
        }
        // by custom ordering
        if (this.state.sortedBy === sort_by_1.SORT_BY.CUSTOM) {
            ret = ret.sort((a, b) => {
                const valA = a.labelData?.user && typeof a.labelData.user.calendarOrder !== typeof null
                    ? a.labelData.user.calendarOrder
                    : 9999999;
                const valB = b.labelData?.user && typeof b.labelData.user.calendarOrder !== typeof null
                    ? b.labelData.user.calendarOrder
                    : 9999999;
                return valA > valB ? 1 : valB > valA ? -1 : 0;
            });
        }
        // finally, separate the external emps from the end of the list
        // by their own separator
        ret = ret.sort((a, b) => {
            return !a.labelData?.user?.external &&
                b.labelData &&
                b.labelData.user &&
                b.labelData.user.external
                ? -1
                : 0;
        });
        const firstExternalIdx = ret.findIndex((r) => r.labelData?.user?.external);
        if (firstExternalIdx !== -1) {
            ret.splice(firstExternalIdx, 0, {
                divider: true,
                dividerContent: (react_1.default.createElement("div", { className: 'ds-external-divider' },
                    react_1.default.createElement("div", null, (0, util_1.t)('EXTERNAL_EX_EMPLOYEES')?.replace(':', '')))),
                events: cols.map(() => []),
            });
        }
        return ret;
    }
    render() {
        const { className, shifts, offers, calendar, availabilities, timeOffs } = this.props;
        const cN = ['ds-calendar', 'is-manager-calendar'];
        if (className)
            cN.push(className);
        // get columns and relevant dates
        const cols = this.getCols();
        const dateStringsInPeriod = cols.map((col) => col.date.format('YYYY-MM-DD'));
        // get shifts, availabilities and timeOffs in relevant period
        const shiftsInPeriod = shifts
            ? shifts
                .filter((s) => s.period?.start &&
                dateStringsInPeriod.includes((0, moment_1.default)(s.period.start).format('YYYY-MM-DD')))
                .map((s) => Object.assign({}, s, { hasOffer: undefined }))
            : [];
        const availsInPeriod = availabilities
            ? availabilities.filter((rec) => rec?.period?.start &&
                dateStringsInPeriod.includes((0, moment_1.default)(rec.period.start).format('YYYY-MM-DD')))
            : [];
        const timeOffsInPeriod = timeOffs
            ? timeOffs.filter((rec) => rec?.period?.start &&
                dateStringsInPeriod.includes((0, moment_1.default)(rec.period.start).format('YYYY-MM-DD')))
            : [];
        // add offers data to the shifts
        offers.forEach((off) => {
            if (off.shiftId) {
                const idx = shiftsInPeriod.findIndex((s) => s.id === off.shiftId);
                if (idx !== -1) {
                    // if there is an offer at this shift, set shift's hasOffer
                    if (off.status !== 'resolved') {
                        shiftsInPeriod[idx].hasOffer = off;
                    }
                }
            }
        });
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(top_bar_1.TopBar, { countWarningsByType: this.state.countWarningsByType, warningCounts: this.state.countWarnings }),
            react_1.default.createElement("div", { className: cN.join(' ') },
                this.props.calendarSettings.calendarShowStatistics ? (react_1.default.createElement(statistics_1.Statistics
                // @ts-expect-error
                , { 
                    // @ts-expect-error
                    shiftsInPeriod: shiftsInPeriod.filter((s) => (0, util_1.isValue)(s.userId) &&
                        !(0, util_1.isValue)(s.hasOffer?.transfer?.master) /* skip unassigned shifts and shifts from external transfers */), 
                    // @ts-expect-error
                    timeOffsInPeriod: timeOffsInPeriod, dateStringsInPeriod: dateStringsInPeriod, labelWidthRem: this.labelWidthRem })) : this.props.calendarSettings.calendarShowCapacities ? (react_1.default.createElement(capacities_1.default
                // @ts-expect-error
                , { 
                    // @ts-expect-error
                    dateStringsInPeriod: dateStringsInPeriod, labelWidthRem: this.labelWidthRem })) : null,
                this.props.calendarSettings.calendarRowTemplates &&
                    util_1.permissionsUtil.canWrite(const_1.PERMISSIONS.CALENDAR) ? (react_1.default.createElement(shift_templates_1.default
                // @ts-expect-error
                , { 
                    // @ts-expect-error
                    cols: cols, labelWidthRem: this.labelWidthRem })) : null,
                react_1.default.createElement(header_1.default
                // @ts-expect-error
                , { 
                    // @ts-expect-error
                    cols: cols, warningsByDate: this.state.countWarningsByDate, sortedBy: this.state.sortedBy, handleSortChange: (val) => {
                        this.setState((s) => Object.assign({}, s, { sortedBy: val }));
                        this.props.loadRoleStatsMulti(calendar.date);
                    } }),
                react_1.default.createElement("div", { className: 'ds-c-sections', style: {
                        maxHeight: util_1.calendarUtil.getComputedCalendarSectionsHeight(calendar),
                    } },
                    this.props.calendarSettings.calendarRowUnassigned ? (react_1.default.createElement("div", { className: 'ds-section-wrapper ds-section-wrapper-unassigned' },
                        react_1.default.createElement(section_1.default, { whichSection: 'unassigned', rows: this.getSectionRows('unassigned', cols, dateStringsInPeriod, shiftsInPeriod, availsInPeriod, timeOffsInPeriod), cols: cols, labelWidthRem: this.labelWidthRem, shiftsInPeriod: shiftsInPeriod, availsInPeriod: availsInPeriod, timeOffsInPeriod: timeOffsInPeriod, dateStringsInPeriod: dateStringsInPeriod }))) : null,
                    this.props.calendarSettings.calendarRowOffers ? (react_1.default.createElement("div", { className: 'ds-section-wrapper ds-section-wrapper-offers' },
                        react_1.default.createElement(section_1.default, { whichSection: 'offers', rows: this.getSectionRows('offers', cols, dateStringsInPeriod, shiftsInPeriod, availsInPeriod, timeOffsInPeriod), cols: cols, labelWidthRem: this.labelWidthRem, shiftsInPeriod: shiftsInPeriod, availsInPeriod: availsInPeriod, timeOffsInPeriod: timeOffsInPeriod, dateStringsInPeriod: dateStringsInPeriod }))) : null,
                    react_1.default.createElement(section_1.default, { whichSection: 'bottom', rows: this.getSectionRows('bottom', cols, dateStringsInPeriod, shiftsInPeriod, availsInPeriod, timeOffsInPeriod), cols: cols, labelWidthRem: this.labelWidthRem, shiftsInPeriod: shiftsInPeriod, availsInPeriod: availsInPeriod, timeOffsInPeriod: timeOffsInPeriod, dateStringsInPeriod: dateStringsInPeriod, sortedBy: this.state.sortedBy })))));
    }
}
exports.default = (0, connect_1.default)((0, use_calendar_settings_1.withUseCalendarSettings)(CalendarManager));
